const userModule = {
  login: {
    url: '/api/auth/jwt/create/',
    method: 'post'
  },
  register: {
    url: '/api/auth/users/',
    method: 'post'
  },
  refreshToken: {
    url: '/api/auth/jwt/refresh/',
    method: 'post'
  },
  verifyToken: {
    url: '/api/auth/jwt/verify/',
    method: 'post'
  },
  userInfo: {
    url: '/api/auth/users/me/',
    method: 'get'
  }
}

const serviceModule = {
  userNewsGroup: {
    url: '/api/config/news_group/',
    method: 'get'
  },
  newsConfig: {
    url: '/api/config/types/',
    method: 'get'
  },
  newsData: {
    url: '/api/news/?type_id=',
    method: 'get'
  }
}

const apiSetting = {
  ...serviceModule,
  ...userModule
}

export default apiSetting



// WEBPACK FOOTER //
// ./src/store/bbnews-api.js